import React from "react";
import Icon from "../icon";

const ExitButton = () => (
  <button
    className="flex items-center exit-button-text text-pale-blue"
    onClick={() =>
      (window.location.href = `${window.location.origin}/collections/gmt`)
    }
  >
    <Icon iconName="ExitArrow" className="mr-2" />
    Exit
  </button>
);

export default ExitButton;
